import { render, staticRenderFns } from "./TextFieldParts.vue?vue&type=template&id=1071d246&"
import script from "./TextFieldParts.vue?vue&type=script&lang=js&"
export * from "./TextFieldParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports